import { Controller } from "@hotwired/stimulus"

// Controls a DaisyUI confirmation modal for destructive actions
// Usage (single modal):
//   <div data-controller="confirm-modal">
//     <button data-action="click->confirm-modal#open">Delete</button>
//     <dialog data-confirm-modal-target="dialog">
//       <button data-action="click->confirm-modal#confirm">Confirm</button>
//       <form data-confirm-modal-target="form" method="post">...</form>
//     </dialog>
//   </div>
//
// Usage (multiple modals with ID):
//   <div data-controller="confirm-modal">
//     <button data-action="click->confirm-modal#open" data-modal-id="my-modal">Delete</button>
//     <dialog id="my-modal">...</dialog>
//   </div>
export default class extends Controller {
  static targets = ["dialog", "form"]

  open(event) {
    event.preventDefault()

    // Check if a specific modal ID is provided
    const modalId = event.currentTarget.dataset.modalId
    if (modalId) {
      const dialog = document.getElementById(modalId)
      if (dialog) {
        dialog.showModal()
      }
    } else {
      this.dialogTarget.showModal()
    }
  }

  close() {
    this.dialogTarget.close()
  }

  confirm() {
    this.formTarget.requestSubmit()
  }
}
